import { render, staticRenderFns } from "./GalaxyAutobuyerBox.vue?vue&type=template&id=0e9d22c8&scoped=true"
import script from "./GalaxyAutobuyerBox.vue?vue&type=script&lang=js"
export * from "./GalaxyAutobuyerBox.vue?vue&type=script&lang=js"
import style0 from "./GalaxyAutobuyerBox.vue?vue&type=style&index=0&id=0e9d22c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9d22c8",
  null
  
)

export default component.exports